enum SentryConsoleEvent {
  ErrorPageHit,
  GlobalErrorBoundaryHit,
  SolanaWalletLinkingError,
  SolanaWalletUnlinkedError,
  TestError,
}

export default SentryConsoleEvent;
